// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fare form (redesign): 2-col layout + live fare preview, matching Category Studio. */

.PricingStudioForm-layout-WF0p7 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 24px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

@media (max-width: 992px) {
  .PricingStudioForm-layout-WF0p7 {
    grid-template-columns: 1fr;
  }
}

.PricingStudioForm-card-Wea62 {
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 18px;
  background: #fff;
  background: var(--white-color, #fff);
}

.PricingStudioForm-preview-N99F6 {
  position: sticky;
  top: 16px;
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 16px;
  background: #f9f9f9;
  background: var(--common-light-bg, #f9f9f9);
}

.PricingStudioForm-previewTitle-Z0RGu {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  margin-bottom: 12px;
}

.PricingStudioForm-fareCard-vrZfn {
  background: #fff;
  background: var(--white-color, #fff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 14px;
  text-align: center;
}

.PricingStudioForm-price-KoJCQ {
  font-weight: 800;
  font-size: 26px;
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
  line-height: 1.1;
}

.PricingStudioForm-priceUnit-ZmuX9 {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  margin-top: 2px;
}

.PricingStudioForm-rows-junzd {
  margin-top: 12px;
  border-top: 1px dashed #e4e4e4;
  border-top: 1px dashed var(--border-color, #e4e4e4);
  padding-top: 10px;
  text-align: left;
}

.PricingStudioForm-lineLabel-jQDr6 {
  font-size: 11px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  text-transform: uppercase;
}

.PricingStudioForm-lineValue-TQjIW {
  font-size: 13px;
  color: #181817;
  color: var(--content-text, #181817);
  margin-bottom: 8px;
  font-weight: 600;
}

.PricingStudioForm-editable-fef0W {
  display: inline-block;
  margin-top: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #0e9488;
  border-radius: 999px;
  padding: 2px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/Pricing/PricingForm/PricingStudioForm.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,gBAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,mBAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAA6C;EAA7C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAoC;EAApC,oCAAoC;EACpC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAiC;EAAjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAAmD;EAAnD,mDAAmD;EACnD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAmC;EAAnC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":["/* Fare form (redesign): 2-col layout + live fare preview, matching Category Studio. */\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 280px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 992px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.card {\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 18px;\n  background: var(--white-color, #fff);\n}\n\n.preview {\n  position: sticky;\n  top: 16px;\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 16px;\n  background: var(--common-light-bg, #f9f9f9);\n}\n\n.previewTitle {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--content-text-secondary, #909090);\n  margin-bottom: 12px;\n}\n\n.fareCard {\n  background: var(--white-color, #fff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 14px;\n  text-align: center;\n}\n\n.price {\n  font-weight: 800;\n  font-size: 26px;\n  color: var(--primary-bg, #d32f2f);\n  line-height: 1.1;\n}\n\n.priceUnit {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n  margin-top: 2px;\n}\n\n.rows {\n  margin-top: 12px;\n  border-top: 1px dashed var(--border-color, #e4e4e4);\n  padding-top: 10px;\n  text-align: left;\n}\n\n.lineLabel {\n  font-size: 11px;\n  color: var(--content-text-secondary, #909090);\n  text-transform: uppercase;\n}\n\n.lineValue {\n  font-size: 13px;\n  color: var(--content-text, #181817);\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.editable {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  background: #0e9488;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `PricingStudioForm-layout-WF0p7`,
	"card": `PricingStudioForm-card-Wea62`,
	"preview": `PricingStudioForm-preview-N99F6`,
	"previewTitle": `PricingStudioForm-previewTitle-Z0RGu`,
	"fareCard": `PricingStudioForm-fareCard-vrZfn`,
	"price": `PricingStudioForm-price-KoJCQ`,
	"priceUnit": `PricingStudioForm-priceUnit-ZmuX9`,
	"rows": `PricingStudioForm-rows-junzd`,
	"lineLabel": `PricingStudioForm-lineLabel-jQDr6`,
	"lineValue": `PricingStudioForm-lineValue-TQjIW`,
	"editable": `PricingStudioForm-editable-fef0W`
};
module.exports = ___CSS_LOADER_EXPORT___;
